/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ComponentProps } from "react";
import { getMessage } from "./helpers";
import { NoData } from "./NoData";

type Props = {
  children: React.ReactNode;
  hasData: boolean;
  messageComponent?: JSX.Element | string;
  fallbackComponentProps?: Partial<ComponentProps<typeof NoData>>;
};

export function ChartDataDisplayWrapper({
  children,
  hasData,
  messageComponent = "No data available",
  fallbackComponentProps = {
    renderOnTop: true,
  },
}: Props) {
  return (
    <div
      css={{
        position: hasData ? "static" : "relative",
      }}
    >
      {hasData ? null : (
        <NoData
          {...fallbackComponentProps}
          message={getMessage(messageComponent)}
        />
      )}
      <div css={{ opacity: hasData ? 1 : 0.15 }}>{children}</div>
    </div>
  );
}
